var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){return _vm.open()}}},[_vm._v("Forgot password?")]),_vm._v(" "),_c('ForgetPasswordModal',{ref:"ForgetPasswordModal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }